import { Component, Input, Output, EventEmitter } from '@angular/core';

import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

@Component({
	selector: 'app-error',
	templateUrl: 'error.component.html',
	styleUrls: ['error.component.scss']
})
export class ErrorComponent {
	iconError = faExclamationTriangle;

	@Input({ required: true })
	heading: string;

	@Input()
	message: string | undefined = $localize`:@@try-again-msg:Please try again and let us know if the issue persists.`;

	@Input()
	class: string = '';

	@Output()
	retry: EventEmitter<void> = new EventEmitter<void>();

	onRetry() {
		this.retry.emit();
	}
}
